import createjs from 'createjs-module';
import { Dimensions } from '../../../../../../../globals/Dimensions';

export class GridItem extends createjs.Container {

  private isSelected?: boolean;
  private rectOff?: createjs.Shape;
  private rectOn?: createjs.Shape;

  constructor() {
    super();
  }

  init() {
    var rectOff = new createjs.Shape();
    rectOff.graphics
      .setStrokeStyle(1)
      .beginStroke('#D3D3D3')
      .beginFill('#FFFFFF')
      .drawRect(0, 0, 24, 24)
      .endFill();
    this.addChild(rectOff);

    var rectOn = new createjs.Shape();
    rectOn.graphics
      .setStrokeStyle(2)
      .beginStroke('#18A0FB')
      .beginFill('#FFFFFF')
      .drawRect(0, 0, 24, 24)
      .endFill();
    this.addChild(rectOn);

    this.rectOff = rectOff;
    this.rectOn = rectOn;

    this.showSelected(false);

    this.setBounds(0,0,24,24);

    this.mouseChildren = false;
    this.mouseEnabled = false;
  }

  public showSelected(value: boolean): void {
    this.isSelected = value;

    if (this.isSelected) {
      this.rectOn!.visible = true;
    } else {
      this.rectOn!.visible = false;
    }
  }
}
